import script from "./MatchMajor.vue?vue&type=script&lang=ts&setup=true"
export * from "./MatchMajor.vue?vue&type=script&lang=ts&setup=true"

import "./MatchMajor.vue?vue&type=style&index=0&id=18a1eb05&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a1eb05"]])

export default __exports__